import { Box, Typography } from "@mui/material";
import LoadingIcon from "../../../../../components/LoadingIcon";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ReactComponent as GoToArrow } from "../../icons/Icons_go_to_(arrow)_24.svg";
export function ViewButton({
  colors,
  title,
  onClick,
  fetchedEntitiesAreLoading,
}) {
  return (
    <Box display="flex" justifyContent="center">
      <Box
        display="flex"
        gap="6px"
        borderRadius="12px"
        alignItems="center"
        height="36px"
        padding="0 12px"
        sx={{
          cursor: "pointer",
          backgroundColor: colors.primary_8percent,
        }}
        onClick={onClick}
        disabled={fetchedEntitiesAreLoading}
      >
        {fetchedEntitiesAreLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            gap="8px"
          >
            <LoadingIcon type="circular" size="16px" />
            <Typography variant="subtitle2" color={colors.primary_300main}>
              loading {title}...
            </Typography>
          </Box>
        ) : (
          <>
            <Typography variant="subtitle2" color={colors.primary_300main}>
              View {title}
            </Typography>
            <SvgToIcon
              IconLogo={GoToArrow}
              style={{ color: colors.primary_300main, width: "16px" }}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
